import gql from "graphql-tag";

const updateBarMutation = gql`
  mutation updateBar(
    $id: ID!
    $name: String!
    $description: String
    $hours: [HoursInput]
    $address: AddressInput
    $imageURLs: [ImageURLInput]!
    $dailySpecials: [DailySpecialInput]!
    $happyHours: [HappyHourInput]!
    $prices: [PriceGroupInput]
    $categories: [String]
    $featured: Boolean
    $published: Boolean
  ) {
    updateBar(
      id: $id
      name: $name
      description: $description
      hours: $hours
      address: $address
      imageURLs: $imageURLs
      dailySpecials: $dailySpecials
      happyHours: $happyHours
      prices: $prices
      categories: $categories
      featured: $featured
      published: $published
    ) {
      _id
      name
      description
      hours {
        open
        close
      }
      address {
        EN
        CH
      }
      imageURLs {
        url
        description
      }
      dailySpecials {
        name
        day
        description
        imageURL
      }
      happyHours {
        day
        startTime
        endTime
        description
        imageURL
      }
      prices {
        name
        beer
        wine
        cocktail
      }
      categories
      featured
      published
    }
  }
`;

export default updateBarMutation;
